export default __webpack_public_path__ + "static/media/thin.1a1b4e99.otf";